module.exports = "<div class=\"container-fluid\" dynamicPage>\r\n    <router-outlet></router-outlet>\r\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/draft/draft.component.html
// module id = ./src/app/views/draft/draft.component.html
// module chunks = main